export function buildQueryString(params = {} as Record<string, unknown>) {
  const query = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    if (params[key]) {
      query.set(key, params[key] as string);
    }
  });

  const queryString = query.toString();

  return queryString ? `?${queryString}` : "";
}


export const buildUrl = (path: string, params?: Record<string, unknown>) => {
  const query = buildQueryString(params);

  return [path, query].filter(Boolean).join("");
};
